module.exports = __webpack_public_path__ + "img/help1-3-1.1963eecc.png";